import Vue from 'vue'
import Router from 'vue-router'

// Containers
import Full from '@/containers/Full'
import Site from '@/containers/Site'

// Views
import Page404 from '@/views/Page404'
import Page500 from '@/views/Page500'
import Login from '@/views/Login'
import Logout from '@/views/Logout'
import Register from '@/views/Register'
import ForgotPassword from '@/views/ForgotPassword'
import Home from '@/views/Home'
import Dashboard from '@/views/Dashboard'
import Accounts from '@/views/Accounts'
import AccountCreate from '@/views/AccountCreate'
import AccountEdit from '@/views/AccountEdit'
import Users from '@/views/Users'
import UserCreate from '@/views/UserCreate'
import UserEdit from '@/views/UserEdit'
import Products from '@/views/Products'
import ProductCreate from '@/views/ProductCreate'
import ProductEdit from '@/views/ProductEdit'
import Packages from '@/views/Packages'
import PackageCreate from '@/views/PackageCreate'
import PackageEdit from '@/views/PackageEdit'
import Coupons from '@/views/Coupons'
import CouponCreate from '@/views/CouponCreate'
import CouponEdit from '@/views/CouponEdit'
import Leads from '@/views/Leads'
import LeadCreate from '@/views/LeadCreate'
import LeadEdit from '@/views/LeadEdit'
import Orders from '@/views/Orders'
import OrderCreate from '@/views/OrderCreate'
import OrderEdit from '@/views/OrderEdit'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/home',
      name: 'Home',
      component: Site,
      children: [
        {
          path: 'home',
          name: 'Home',
          component: Home
        }
      ]
    },
    {
      path: '/',
      name: 'Logout',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: 'logout',
          name: 'Logout',
          component: Logout
        }
      ]
    },
    {
      path: '/',
      name: 'Full',
      component: Full,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'accounts',
          name: 'Accounts',
          component: Accounts
        },
        {
          path: 'accounts/create',
          name: 'AccountCreate',
          component: AccountCreate
        },
        {
          path: 'accounts/edit/:id',
          name: 'AccountEdit',
          component: AccountEdit
        },
        {
          path: 'users',
          name: 'Users',
          component: Users
        },
        {
          path: 'users/create',
          name: 'UserCreate',
          component: UserCreate
        },
        {
          path: 'users/edit/:id',
          name: 'UserEdit',
          component: UserEdit
        },
        {
          path: 'products',
          name: 'Products',
          component: Products
        },
        {
          path: 'products/create',
          name: 'ProductCreate',
          component: ProductCreate
        },
        {
          path: 'products/edit/:id',
          name: 'ProductEdit',
          component: ProductEdit
        },
        {
          path: 'packages',
          name: 'Packages',
          component: Packages
        },
        {
          path: 'packages/create',
          name: 'PackageCreate',
          component: PackageCreate
        },
        {
          path: 'packages/edit/:id',
          name: 'PackageEdit',
          component: PackageEdit
        },
        {
          path: 'coupons',
          name: 'Coupons',
          component: Coupons
        },
        {
          path: 'coupons/create',
          name: 'CouponCreate',
          component: CouponCreate
        },
        {
          path: 'coupons/edit/:id',
          name: 'CouponEdit',
          component: CouponEdit
        },
        {
          path: 'leads',
          name: 'Leads',
          component: Leads
        },
        {
          path: 'leads/create',
          name: 'LeadCreate',
          component: LeadCreate
        },
        {
          path: 'leads/edit/:id',
          name: 'LeadEdit',
          component: LeadEdit
        },
        {
          path: 'orders',
          name: 'Orders',
          component: Orders
        },
        {
          path: 'orders/create',
          name: 'OrderCreate',
          component: OrderCreate
        },
        {
          path: 'orders/edit/:id',
          name: 'OrderEdit',
          component: OrderEdit
        }
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'signin',
          name: 'Login',
          component: Login
        },
        {
          path: 'signup',
          name: 'Register',
          component: Register
        },
        {
          path: 'reset',
          name: 'ForgotPassword',
          component: ForgotPassword
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js